
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[resort]/webcams",
      function () {
        return require("private-next-pages/[region]/[resort]/webcams.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[resort]/webcams"])
      });
    }
  